module.exports = __webpack_public_path__ + "static/media/arif-staff-web-hubton.d804cfbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/people/arif-staff-web-hubton.png
// module id = 178
// module chunks = 0